import { render, staticRenderFns } from "./edit-note-modal.vue?vue&type=template&id=ce546000&lang=pug"
import script from "./edit-note-modal.vue?vue&type=script&lang=js"
export * from "./edit-note-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports